export default __webpack_public_path__ + "static/media/Licences.e9a15eab.jpg";